import { useEffect, useState } from "react";
import { answerDeskService } from "../services/answerDeskService";

/** Answer Desk items waiting for Owner/Manager (questions, suggestions,
 * flags) — the sidebar badge. Disabled for everyone else. */
export const useAnswerDeskCount = (enabled: boolean, refreshInterval: number = 60000): number => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!enabled) {
            setCount(0);
            return;
        }
        let cancelled = false;
        const fetchCount = async () => {
            try {
                const result = await answerDeskService.getReviewCounts();
                if (!cancelled) setCount(result.total_waiting ?? 0);
            } catch {
                // non-critical badge
            }
        };
        fetchCount();
        const interval = setInterval(fetchCount, refreshInterval);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [enabled, refreshInterval]);

    return count;
};
